import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="transparent"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M10.5 11H14.0729C15.188 11 15.9133 9.82653 15.4146 8.82918L12.7896 3.57918C12.5355 3.071 12.0161 2.75 11.4479 2.75H8.43466C8.31202 2.75 8.18984 2.76504 8.07085 2.79479L5.25 3.5M10.5 11V14.75C10.5 15.5784 9.82843 16.25 9 16.25H8.92839C8.55373 16.25 8.25 15.9463 8.25 15.5716C8.25 15.0359 8.09142 14.5121 7.79426 14.0664L5.25 10.25V3.5M10.5 11H9M5.25 3.5H3.75C2.92157 3.5 2.25 4.17157 2.25 5V9.5C2.25 10.3284 2.92157 11 3.75 11H5.625" />
  </svg>
);
